// Packages
import { createApp, defineAsyncComponent } from 'vue';

// Vue components
import SearchList from '@vue-components/SearchList.vue';

export default function init(): void {
  const el = document.querySelector<HTMLElement>('#search-index')!;

  // Create Vue instance for people search
  const vueInstance = createApp({
    name: 'SearchIndex',
    compilerOptions: {
      delimiters: ['${', '}'],
    },
    components: {
      SearchList,
      CareerCard: defineAsyncComponent(() => import('@vue-components/cards/CareerCard.vue')),
    },
  });

  vueInstance.config.globalProperties.navigator = window.navigator;

  // Mount the app
  vueInstance.mount(el);
}
